export const EM_DASH = '—';
export const MAX_INT32 = 2 ** 31 - 1; // 2147483647 (hex 0x7FFFFFFF)

let ticketServicePartUrl = 'https://service.kkts.com.au/#ticket/zoom/';
if (import.meta.env.VITE_APP_BRAND === 'pac') {
  // TODO pac value for ticket service
  ticketServicePartUrl = '/404/';
}

export const TICKET_SERVICE_PART_URL = ticketServicePartUrl;
